import React from 'react';
import { toast } from 'react-hot-toast';

/**
 * 👥 JAMOA — loyiha a'zolari, rollar va taklif havolalari (F1, 2026-09-25).
 *
 * Rollar serverda (services/projectAccess.js) tekshiriladi; bu panel faqat boshqaruv
 * yuzasi. Egasi bo'lmagan a'zo ro'yxatni ko'radi, o'zgartira olmaydi.
 * `authFetch` har render'da yangi identity — effekt dep'iga QO'YILMAYDI (ref orqali).
 */

const ROLE_INFO = {
  owner: { label: '👑 Egasi', cls: 'bg-amber-100 dark:bg-amber-900/40 text-amber-800 dark:text-amber-300',
    desc: "Hammasi: prod deploy, 🚀 Publish, 🔑 Sirlar, modul va test muhiti sozlamalari, a'zolarni boshqarish, loyihani o'chirish." },
  developer: { label: "👨‍💻 Dasturchi", cls: 'bg-blue-100 dark:bg-blue-900/40 text-blue-800 dark:text-blue-300',
    desc: "Vazifa beradi, rejani va ishni tasdiqlaydi, emulator/brauzer/sinovlardan foydalanadi. Prod, Publish va sirlarga tegolmaydi." },
  reviewer: { label: '🔍 Tekshiruvchi', cls: 'bg-purple-100 dark:bg-purple-900/40 text-purple-800 dark:text-purple-300',
    desc: "Tayyor ishni sinab ko'radi va tasdiqlaydi, vazifa ham bera oladi. Prod, Publish va sirlarga tegolmaydi." },
  viewer: { label: '👁 Kuzatuvchi', cls: 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300',
    desc: "Faqat ko'radi: vazifalar, loglar, hujjatlar. Hech narsani o'zgartira olmaydi." },
  client: { label: '🤝 Mijoz', cls: 'bg-teal-100 dark:bg-teal-900/40 text-teal-800 dark:text-teal-300',
    desc: "Buyurtmachi: xarita, sinov topilmalari, hujjatlar, crashlar va vazifalar holatini ko'radi; vazifa va izoh qoldiradi — har vazifasi sizning ruxsatingizdan keyin boshlanadi. Kod, baza, server, emulator, agent jurnali va sarf unga ko'rinmaydi. Taklif bilan kelsa faqat Studio va Jarayonlar bo'limlari ochiladi." },
};
const ROLE_KEYS = ['owner', 'developer', 'reviewer', 'viewer', 'client'];
const fmtDate = (v) => {
  if (!v) return '';
  const d = new Date(v);
  if (isNaN(d)) return '';
  const p = (n) => String(n).padStart(2, '0');
  return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()}`;
};

export default function TeamPanel({ authFetch, apiUrl, projectId }) {
  const fetchRef = React.useRef(authFetch);
  fetchRef.current = authFetch;
  const [data, setData] = React.useState(null);
  const [err, setErr] = React.useState('');
  const [busy, setBusy] = React.useState('');
  const [invRole, setInvRole] = React.useState('developer');
  const [newLink, setNewLink] = React.useState(null);
  const [addName, setAddName] = React.useState('');
  const [addRole, setAddRole] = React.useState('developer');
  const [tg, setTg] = React.useState(null);           // {linked, bot}
  const [tgLink, setTgLink] = React.useState(null);   // {url}
  const [acts, setActs] = React.useState(null);
  const [cl, setCl] = React.useState(null);         // 🤖 {hasToken, platform, connectedAt}
  const [clTok, setClTok] = React.useState('');
  const [clOpen, setClOpen] = React.useState(false);
  const [actsMore, setActsMore] = React.useState(false);

  const call = React.useCallback(async (path, opts = {}) => {
    const res = await fetchRef.current(`${apiUrl}${path}`, {
      ...opts, headers: { 'Content-Type': 'application/json', ...(opts.headers || {}) },
    });
    const d = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(d.error || 'Server xatosi');
    return d;
  }, [apiUrl]);

  const load = React.useCallback(async () => {
    if (!projectId) return;
    try { setErr(''); setData(await call(`/projects/${projectId}/members`)); }
    catch (e) { setErr(e.message); }
  }, [call, projectId]);
  React.useEffect(() => { setData(null); setNewLink(null); load(); }, [load]);

  // 📨 Shaxsiy Telegram (foydalanuvchiga tegishli, loyihaga emas)
  const loadTg = React.useCallback(async () => { try { setTg(await call('/me/telegram')); } catch (e) { setTg({ linked: false, bot: null, error: e.message }); } }, [call]);
  React.useEffect(() => { loadTg(); }, [loadTg]);
  // Havola ochilgach foydalanuvchi botda /start bosadi — holatni bir necha marta tekshiramiz.
  React.useEffect(() => {
    if (!tgLink || (tg && tg.linked)) return undefined;
    const t = setInterval(loadTg, 4000);
    const stop = setTimeout(() => clearInterval(t), 5 * 60_000);
    return () => { clearInterval(t); clearTimeout(stop); };
  }, [tgLink, tg, loadTg]);

  // 🤖 Shaxsiy Claude hisobi (F3)
  const loadCl = React.useCallback(async () => { try { setCl(await call('/me/claude')); } catch (e) { setCl({ error: e.message }); } }, [call]);
  React.useEffect(() => { loadCl(); }, [loadCl]);
  const saveCl = async () => {
    setBusy('cl');
    try { await call('/me/claude', { method: 'PUT', body: JSON.stringify({ token: clTok.trim() }) }); setClTok(''); setClOpen(false); toast.success('🤖 Claude hisobingiz ulandi'); loadCl(); }
    catch (e) { toast.error(e.message); }
    finally { setBusy(''); }
  };
  const setSetting = (patch, msg) => act('set', () => call(`/projects/${projectId}/team-settings`, { method: 'PUT', body: JSON.stringify(patch) }), msg);

  // 📜 Faoliyat lentasi
  const loadActs = React.useCallback(async (before = null) => {
    if (!projectId) return;
    try {
      const rows = await call(`/projects/${projectId}/activity?limit=30${before ? `&before=${before}` : ''}`);
      setActs(prev => (before ? [...(prev || []), ...rows] : rows));
      setActsMore(rows.length === 30);
    } catch (e) { if (!before) setActs([]); }
  }, [call, projectId]);
  React.useEffect(() => { setActs(null); loadActs(); }, [loadActs]);

  const act = async (key, fn, okMsg) => {
    setBusy(key);
    try { await fn(); if (okMsg) toast.success(okMsg); await load(); loadActs(); }
    catch (e) { toast.error(e.message); }
    finally { setBusy(''); }
  };

  const isOwner = data && data.myRole === 'owner';
  const members = (data && data.members) || [];

  const createInvite = () => act('invite', async () => {
    const d = await call(`/projects/${projectId}/invites`, { method: 'POST', body: JSON.stringify({ role: invRole }) });
    setNewLink(d);
    try { await navigator.clipboard.writeText(d.url); toast.success('🔗 Havola nusxalandi'); } catch (e) { /* qo'lda nusxalanadi */ }
  });

  if (!projectId) return <div className="p-6 text-sm text-gray-500">Avval loyihani tanlang.</div>;

  return (
    <div className="p-5 max-w-5xl">
      <div className="flex items-center justify-between gap-3 mb-1">
        <h3 className="text-lg font-bold text-gray-900 dark:text-white">👥 Jamoa</h3>
        {data && data.myRole && (
          <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${ROLE_INFO[data.myRole]?.cls || ''}`}>
            Sizning rolingiz: {ROLE_INFO[data.myRole]?.label || data.myRole}
          </span>
        )}
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
        Loyihada kim ishlaydi va nima qila oladi. Vazifani kim berganini, kim tasdiqlaganini ⏳ Jarayonlar kartasida ko'rasiz.
      </p>
      <div className="mb-4 flex flex-wrap items-center gap-2 text-sm bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg px-4 py-2.5">
        <span className="font-semibold text-gray-900 dark:text-white">📨 Telegram</span>
        {!tg && <span className="text-gray-400">⏳</span>}
        {tg && tg.linked && (<>
          <span className="text-green-700 dark:text-green-400">✅ ulangan — savol, reja, tasdiq, natija va @eslatishlar shu yerga keladi</span>
          <button onClick={async () => { try { await call('/me/telegram', { method: 'DELETE' }); setTgLink(null); loadTg(); } catch (e) { toast.error(e.message); } }}
            className="ml-auto px-2 py-1 text-xs text-gray-500 hover:text-red-600">Uzish</button>
        </>)}
        {tg && !tg.linked && (<>
          <span className="text-gray-500 dark:text-gray-400">ulanmagan — xabarlar faqat push orqali keladi</span>
          <button onClick={async () => { try { const d = await call('/me/telegram/link', { method: 'POST' }); setTgLink(d); window.open(d.url, '_blank', 'noopener'); } catch (e) { toast.error(e.message); } }}
            className="ml-auto px-3 py-1 text-xs font-semibold bg-primary-700 text-white rounded-lg hover:bg-primary-800">📨 Telegram ulash</button>
        </>)}
        {tgLink && tg && !tg.linked && (
          <div className="w-full text-xs text-gray-500 dark:text-gray-400">
            Telegram'da <b translate="no">@{tgLink.bot}</b> ochildi — <b>Start</b> ni bosing. Ochilmagan bo'lsa: <a href={tgLink.url} target="_blank" rel="noopener noreferrer" className="text-primary-700 dark:text-primary-400 underline" translate="no">{tgLink.url}</a> (15 daqiqa amal qiladi)
          </div>
        )}
      </div>
      <div className="mb-4 text-sm bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg px-4 py-2.5">
        <div className="flex flex-wrap items-center gap-2">
          <span className="font-semibold text-gray-900 dark:text-white">🤖 Claude hisobi</span>
          {!cl && <span className="text-gray-400">⏳</span>}
          {cl && cl.hasToken && <span className="text-green-700 dark:text-green-400">✅ o'z hisobingiz ulangan — siz bergan vazifalar shu obunada ishlaydi</span>}
          {cl && !cl.hasToken && cl.platform && <span className="text-gray-500 dark:text-gray-400">platforma hisobida ishlaysiz (o'zingiznikini ulashingiz mumkin)</span>}
          {cl && !cl.hasToken && !cl.platform && <span className="text-amber-600 dark:text-amber-400">ulanmagan — vazifalaringiz loyiha egasining hisobida ishlaydi (egasi ruxsat bergan bo'lsa), aks holda boshlanmaydi</span>}
          {cl && cl.hasToken
            ? <button onClick={async () => { if (!window.confirm('Claude hisobingiz uzilsinmi?')) return; try { await call('/me/claude', { method: 'DELETE' }); loadCl(); } catch (e) { toast.error(e.message); } }} className="ml-auto px-2 py-1 text-xs text-gray-500 hover:text-red-600">Uzish</button>
            : cl && <button onClick={() => setClOpen(v => !v)} className="ml-auto px-3 py-1 text-xs font-semibold bg-primary-700 text-white rounded-lg hover:bg-primary-800">🔑 Tokenni ulash</button>}
        </div>
        {clOpen && (
          <div className="mt-2 text-xs text-gray-600 dark:text-gray-300 space-y-2">
            <div>O'z kompyuteringizda (Claude Code o'rnatilgan) terminalda <code className="px-1 bg-gray-100 dark:bg-gray-700 rounded" translate="no">claude setup-token</code> ni ishga tushiring — brauzerda Claude'ga kirasiz va u <code translate="no">sk-ant-…</code> token beradi. Shu tokenni bu yerga qo'ying. Token shifrlangan saqlanadi va hech qayerda ko'rsatilmaydi; ulashdan oldin bitta qisqa so'rov bilan tekshiriladi.</div>
            <div className="flex gap-2">
              <input type="password" value={clTok} onChange={e => setClTok(e.target.value)} placeholder="sk-ant-oat01-…" autoComplete="off" translate="no"
                className="flex-1 min-w-0 text-xs font-mono border border-gray-200 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-lg px-2 py-1.5" />
              <button onClick={saveCl} disabled={busy === 'cl' || !clTok.trim()} className="px-3 py-1.5 text-xs font-semibold bg-primary-700 text-white rounded-lg hover:bg-primary-800 disabled:opacity-50">{busy === 'cl' ? '⏳ Tekshirilmoqda…' : 'Ulash'}</button>
            </div>
          </div>
        )}
      </div>
      {err && <div className="mb-3 text-sm text-red-600 dark:text-red-400">{err}</div>}
      {!data && !err && <div className="text-sm text-gray-400">⏳ Yuklanmoqda…</div>}

      {data && (
        <>
          <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden mb-5">
            <table className="w-full text-sm">
              <thead className="bg-gray-50 dark:bg-gray-700/50 text-xs text-gray-500 dark:text-gray-400 uppercase">
                <tr>
                  <th className="text-left px-4 py-2 font-semibold">A'zo</th>
                  <th className="text-left px-4 py-2 font-semibold">Rol</th>
                  <th className="text-left px-4 py-2 font-semibold hidden sm:table-cell">Qo'shilgan</th>
                  {isOwner && <th className="px-4 py-2" />}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100 dark:divide-gray-700">
                {members.map(m => (
                  <tr key={m.user_id}>
                    <td className="px-4 py-2.5 text-gray-900 dark:text-white">
                      <span translate="no">{m.username}</span>
                      {m.is_me && <span className="ml-1.5 text-xs text-gray-400">(siz)</span>}
                      {Number(m.is_active) === 0 && <span className="ml-1.5 text-xs text-red-500">o'chirilgan hisob</span>}
                    </td>
                    <td className="px-4 py-2.5">
                      {isOwner ? (
                        <select value={m.role} disabled={busy === 'r' + m.user_id}
                          onChange={e => act('r' + m.user_id, () => call(`/projects/${projectId}/members/${m.user_id}`, { method: 'PUT', body: JSON.stringify({ role: e.target.value }) }), 'Rol o‘zgartirildi')}
                          className="text-sm border border-gray-200 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-lg px-2 py-1">
                          {ROLE_KEYS.map(r => <option key={r} value={r}>{ROLE_INFO[r].label}</option>)}
                        </select>
                      ) : (
                        <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${ROLE_INFO[m.role]?.cls || ''}`}>{ROLE_INFO[m.role]?.label || m.role}</span>
                      )}
                      {/* 🔎 Agentga savol (2026-11-04): egasi/dasturchi agentdan to'liq foydalanadi; boshqa rolga — faqat savol-javob
                          (vazifa berish va o'zgartirishsiz). Server: user_projects.agent_ask, operatorAgent.modeFor 'ask'. */}
                      {!['owner', 'developer'].includes(m.role) && (isOwner ? (
                        <label data-kh="team-agent-ask" title="Yoqilsa a'zo 🧠 Loyiha agentidan SAVOL so'ray oladi: agent kodni, test muhitni va vazifalar holatini o'qib javob beradi. Vazifa berish, tasdiqlash, sinov va hech qanday o'zgartirish yo'q — agent so'rovni operatorga yuborish uchun matn tayyorlab beradi."
                          className="mt-1 flex items-center gap-1.5 text-xs text-gray-600 dark:text-gray-300 cursor-pointer select-none">
                          <input type="checkbox" checked={!!m.agent_ask} disabled={busy === 'a' + m.user_id}
                            onChange={e => act('a' + m.user_id, () => call(`/projects/${projectId}/members/${m.user_id}`, { method: 'PUT', body: JSON.stringify({ agent_ask: e.target.checked }) }),
                              e.target.checked ? "🔎 Agentga savol ruxsati berildi" : "🔎 Agentga savol ruxsati olindi")}
                            className="rounded" />
                          🔎 Agentga savol
                        </label>
                      ) : m.agent_ask ? (
                        <span className="mt-1 inline-block text-xs text-sky-700 dark:text-sky-300">🔎 Agentga savol bera oladi</span>
                      ) : null)}
                    </td>
                    <td className="px-4 py-2.5 text-gray-500 dark:text-gray-400 hidden sm:table-cell">{fmtDate(m.joined_at)}</td>
                    {isOwner && (
                      <td className="px-4 py-2.5 text-right">
                        <button disabled={busy === 'd' + m.user_id}
                          onClick={() => { if (window.confirm(`${m.username} loyihadan chiqarilsinmi? Uning vazifalari va tarixi saqlanadi.`)) act('d' + m.user_id, () => call(`/projects/${projectId}/members/${m.user_id}`, { method: 'DELETE' }), 'A‘zo chiqarildi'); }}
                          className="px-2 py-1 text-xs text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/30 rounded-lg disabled:opacity-50">
                          Chiqarish
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {isOwner && data.settings && (
            <div className="mb-5 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-4 space-y-3">
              <div className="text-sm font-semibold text-gray-900 dark:text-white">⚙️ Jamoa sozlamalari</div>
              <label className="flex items-start gap-2 text-sm cursor-pointer">
                <input type="checkbox" className="mt-1" checked={!!data.settings.fourEyes} disabled={busy === 'set'}
                  onChange={e => setSetting({ fourEyes: e.target.checked }, e.target.checked ? "👥 «To'rt ko'z» yoqildi" : "«To'rt ko'z» o'chirildi")} />
                <span><b>👥 «To'rt ko'z» tasdiqlash</b><br /><span className="text-xs text-gray-500 dark:text-gray-400">Hech kim o'zi bergan vazifani tasdiqlay olmaydi; tasdiqni faqat 🔍 tekshiruvchi yoki 👑 egasi beradi; 🚀 avto-deploy o'chadi.</span></span>
              </label>
              <label className="flex items-start gap-2 text-sm cursor-pointer">
                <input type="checkbox" className="mt-1" checked={!!data.settings.allowOwnerClaude} disabled={busy === 'set'}
                  onChange={e => setSetting({ allowOwnerClaude: e.target.checked }, e.target.checked ? "A'zolar egasi Claude hisobidan foydalana oladi" : "A'zolar faqat o'z Claude hisobida ishlaydi")} />
                <span><b>🤖 A'zolar mening Claude hisobimdan foydalansin</b><br /><span className="text-xs text-gray-500 dark:text-gray-400">O'z Claude tokenini ulamagan a'zoning vazifalari egasining hisobida ishlaydi. O'chirilsa — tokensiz a'zoning vazifasi boshlanmaydi.</span></span>
              </label>
              {/* 🧠 Agent o'zi tasdiqlasin (2026-11-04, tezlik tahlili — backend docs/knowledge/209): reja tayyor / vazifa tugaganda Loyiha agentiga
                  xabar keladi (#31); yoqilsa agent reja va natijani o'zi ko'rib tasdiqlaydi (shubhali / prod / ma'lumot o'chirishda — so'raydi). */}
              <label className="flex items-start gap-2 text-sm cursor-pointer" data-kh="team-agent-auto-approve">
                <input type="checkbox" className="mt-1" checked={!!data.settings.agentAutoApprove} disabled={busy === 'set' || !!data.settings.fourEyes}
                  onChange={e => setSetting({ agentAutoApprove: e.target.checked }, e.target.checked ? "🧠 Agent endi reja va natijani o'zi tasdiqlaydi" : "Tasdiqni yana o'zingiz berasiz")} />
                <span><b>🧠 Agent reja va natijani o'zi tasdiqlasin</b><br /><span className="text-xs text-gray-500 dark:text-gray-400">Reja tayyor bo'lganda yoki vazifa tugaganda 🧠 Loyiha agenti uni o'zi ko'rib, mos bo'lsa tasdiqlaydi va sizga qisqa aytadi — kutish yo'qoladi. Shubhali, xavfli (prod, pul, ma'lumot o'chirish) holatda sizdan so'raydi.{data.settings.fourEyes ? " «To'rt ko'z» yoqilganda ishlamaydi." : ''}</span></span>
              </label>
            </div>
          )}

          {isOwner && (
            <div className="grid md:grid-cols-2 gap-4 mb-5">
              <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-4">
                <div className="text-sm font-semibold text-gray-900 dark:text-white mb-1">🔗 Taklif havolasi</div>
                <p className="text-xs text-gray-500 dark:text-gray-400 mb-3">Bir martalik, 7 kun amal qiladi. Yangi odam havolani ochib o'zi hisob yaratadi; hisobi borlar kirib qo'shiladi.</p>
                <div className="flex gap-2">
                  <select value={invRole} onChange={e => setInvRole(e.target.value)}
                    className="text-sm border border-gray-200 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-lg px-2 py-1.5">
                    {ROLE_KEYS.map(r => <option key={r} value={r}>{ROLE_INFO[r].label}</option>)}
                  </select>
                  <button onClick={createInvite} disabled={busy === 'invite'}
                    className="px-3 py-1.5 text-sm font-semibold bg-primary-700 text-white rounded-lg hover:bg-primary-800 disabled:opacity-50">
                    {busy === 'invite' ? '⏳' : '🔗 Havola yaratish'}
                  </button>
                </div>
                {newLink && (
                  <div className="mt-3">
                    <div className="flex gap-2">
                      <input readOnly value={newLink.url} onFocus={e => e.target.select()} translate="no"
                        className="flex-1 min-w-0 text-xs font-mono border border-gray-200 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-lg px-2 py-1.5" />
                      <button onClick={async () => { try { await navigator.clipboard.writeText(newLink.url); toast.success('Nusxalandi'); } catch (e) { toast.error('Qo‘lda nusxalang'); } }}
                        className="px-2.5 py-1.5 text-xs border border-gray-200 dark:border-gray-600 rounded-lg dark:text-white">📋 Nusxalash</button>
                    </div>
                    <div className="mt-1 text-[11px] text-amber-600 dark:text-amber-400">Havola faqat hozir ko'rinadi — yo'qotsangiz yangisini yarating.</div>
                  </div>
                )}
              </div>

              <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-4">
                <div className="text-sm font-semibold text-gray-900 dark:text-white mb-1">➕ Mavjud foydalanuvchini qo'shish</div>
                <p className="text-xs text-gray-500 dark:text-gray-400 mb-3">Khorezmai'da hisobi bor odam — foydalanuvchi nomi bo'yicha.</p>
                <div className="flex gap-2">
                  <input value={addName} onChange={e => setAddName(e.target.value)} placeholder="foydalanuvchi nomi"
                    className="flex-1 min-w-0 text-sm border border-gray-200 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-lg px-2 py-1.5" />
                  <select value={addRole} onChange={e => setAddRole(e.target.value)}
                    className="text-sm border border-gray-200 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-lg px-2 py-1.5">
                    {ROLE_KEYS.map(r => <option key={r} value={r}>{ROLE_INFO[r].label}</option>)}
                  </select>
                  <button disabled={busy === 'add' || !addName.trim()}
                    onClick={() => act('add', async () => { await call(`/projects/${projectId}/members`, { method: 'POST', body: JSON.stringify({ username: addName.trim(), role: addRole }) }); setAddName(''); }, 'A‘zo qo‘shildi')}
                    className="px-3 py-1.5 text-sm font-semibold bg-primary-700 text-white rounded-lg hover:bg-primary-800 disabled:opacity-50">Qo'shish</button>
                </div>
              </div>
            </div>
          )}

          {isOwner && (data.invites || []).length > 0 && (
            <div className="mb-5">
              <div className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase mb-2">Kutilayotgan takliflar</div>
              <div className="space-y-1.5">
                {data.invites.map(i => (
                  <div key={i.id} className="flex items-center justify-between gap-2 text-sm bg-gray-50 dark:bg-gray-700/40 rounded-lg px-3 py-2">
                    <span className="text-gray-700 dark:text-gray-300">
                      {ROLE_INFO[i.role]?.label || i.role} · {fmtDate(i.expires_at)} gacha{i.created_by_name ? ` · ${i.created_by_name}` : ''}
                    </span>
                    <button disabled={busy === 'v' + i.id}
                      onClick={() => act('v' + i.id, () => call(`/projects/${projectId}/invites/${i.id}`, { method: 'DELETE' }), 'Taklif bekor qilindi')}
                      className="px-2 py-1 text-xs text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/30 rounded-lg disabled:opacity-50">Bekor qilish</button>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="mb-5">
            <div className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase mb-2">📜 Faoliyat</div>
            {acts === null && <div className="text-sm text-gray-400">⏳</div>}
            {acts && acts.length === 0 && <div className="text-sm text-gray-400">Hali yozuv yo'q — vazifa, tasdiq, deploy, sir va a'zolik o'zgarishlari shu yerda ko'rinadi.</div>}
            {acts && acts.length > 0 && (
              <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg divide-y divide-gray-100 dark:divide-gray-700">
                {acts.map(a => (
                  <div key={a.id} className="px-4 py-2 text-sm flex gap-3">
                    <span className="shrink-0 w-24 text-xs text-gray-400 pt-0.5">{fmtDate(a.created_at)} {(() => { const d = new Date(a.created_at); return isNaN(d) ? '' : `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`; })()}</span>
                    <span className="min-w-0 text-gray-700 dark:text-gray-300 break-words">
                      <b className="text-gray-900 dark:text-white" translate="no">{a.username || '🤖 Khorezmai'}</b> <span translate="no">{a.summary}</span>
                    </span>
                  </div>
                ))}
              </div>
            )}
            {actsMore && (
              <button onClick={() => loadActs(acts[acts.length - 1].id)} className="mt-2 text-xs text-primary-700 dark:text-primary-400 hover:underline">Ko'proq</button>
            )}
          </div>

          <div className="grid sm:grid-cols-2 gap-2">
            {ROLE_KEYS.map(r => (
              <div key={r} className="text-xs bg-gray-50 dark:bg-gray-700/40 rounded-lg px-3 py-2">
                <span className={`px-1.5 py-0.5 rounded-full font-semibold ${ROLE_INFO[r].cls}`}>{ROLE_INFO[r].label}</span>
                <div className="mt-1 text-gray-600 dark:text-gray-400">{ROLE_INFO[r].desc}</div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
